import React, { useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import {useSelector} from "react-redux";
import ReactCalendar from "react-calendar";
import {subtractYears} from "@awe-web/shared/lib";
import {getCurrentLocale} from "@awe-web/shared/lib";
import {getCurrentDateTime} from "@awe-web/shared/lib";
import {dateToAbbreviatedWeekdayName, dateToMonthName} from "../l10n/store.js";

import "./calendar.scss";

export default function Calendar({
  className,
  value,
  startDate,
  minDate,
  defaultView = 'month',
  onSelect = () => {},
  isDateEnabled = () => true
}) {

  const currentLocale = useSelector((state) => getCurrentLocale(state));
  const currentDateTime = useSelector((state) => getCurrentDateTime(state));
  const getDateToAbbreviatedWeekdayName = useSelector(dateToAbbreviatedWeekdayName);

  const activeStartDate = useMemo(() => {
    return startDate ? startDate : currentDateTime;
  }, [currentDateTime, startDate]);

  const localMinDate = useMemo(() => {
    return minDate
      ? (startDate ? startDate : minDate)
      : subtractYears(currentDateTime, 100);
  }, [currentDateTime, minDate, startDate]);

  const compoundClassName = classnames("calendar", className);

  const localDateToMonthName = useSelector((state) => dateToMonthName(state));

  const formatMonth = useCallback((locale, date) => localDateToMonthName(date), [localDateToMonthName]);
  const formatMonthYear = useCallback((locale, date) => `${localDateToMonthName(date)} ${date.getFullYear()}`, [localDateToMonthName]);

  const formatShortWeekday = useCallback((locale, date) => {
    return getDateToAbbreviatedWeekdayName(date);
  }, [getDateToAbbreviatedWeekdayName]);

  return (
    <ReactCalendar
      value={value}
      className={compoundClassName}
      onClickDay={onSelect}
      tileDisabled={({date}) => !isDateEnabled(date)}
      defaultView={defaultView}
      locale={currentLocale}
      defaultActiveStartDate={activeStartDate}
      minDate={localMinDate}
      formatMonth={formatMonth}
      formatMonthYear={formatMonthYear}
      formatShortWeekday={formatShortWeekday}
    />
  );
}

Calendar.view = {
  MONTH: "month",
  YEAR: "year",
  DECADE: "decade",
  CENTURY: "century"
};

Calendar.propTypes = {
  className: PropTypes.string,
  value: PropTypes.instanceOf(Date),
  minDate: PropTypes.instanceOf(Date),
  firstActiveDate: PropTypes.instanceOf(Date),
  defaultView: PropTypes.string,
  isBirthdayInput: PropTypes.bool,
  onSelect: PropTypes.func,
  isDateEnabled: PropTypes.func,
};
